import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import MaintenanceSpecificationValueItem from "./MaintenanceSpecificationValueItem";
import DropdownMenu from "@/common/components/DropdownMenu";
import { cn } from "@/common/utils/cn";
import { buttonVariants } from "@/common/components/Button/styles";
import UpdateMaintenanceSpecificationModal from "./UpdateMaintenanceSpecificationModal";
import { useState } from "react";
import DeleteMaintenanceSpecificationModal from "./DeleteMaintenanceSpecificationModal";

interface MaintenanceSpecificationItemProps {
  establishmentCompany: EstablishmentCompanyData;
  maintenanceSpecification: EstablishmentCompanyData['maintenance_specifications'][number];
  alertText: {
    title: string;
    description: string;
  };
  disabled?: boolean;
}

const MaintenanceSpecificationItem = ({
  establishmentCompany,
  maintenanceSpecification,
  alertText,
  disabled,
}: MaintenanceSpecificationItemProps) => {
  const [updateIsOpen, setUpdateIsOpen] = useState(false);
  const [deleteIsOpen, setDeleteIsOpen] = useState(false);

  return (
    <div
      className="bg-white-100 p-4 rounded-md flex flex-col gap-3"
    >
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-2 flex-1">
          <MaintenanceSpecificationValueItem
            label="Categorias do equipamento"
            value={maintenanceSpecification.equipment_category_specifications?.map(
              ({ category }) => category.display_name
            )?.join(', ') || '--'}
          />

          <MaintenanceSpecificationValueItem
            label="Fabricantes"
            value={maintenanceSpecification.equipment_manufacturer_specifications?.map(
              ({ manufacturer }) => manufacturer.display_name
            )?.join(', ') || '--'}
          />

          <MaintenanceSpecificationValueItem
            label="Sistemas de manutenção atendidos"
            value={maintenanceSpecification.system_specifications?.map(
              ({ system }) => system.display_name
            )?.join(', ') || '--'}
          />
        </div>

        <div>
          <DropdownMenu
            triggerClassName={cn(buttonVariants({ variant: 'neutral' }))}
            menuPositionAlign="end"
            triggerLabel="Opções"
            disabled={disabled}
            options={[
              {
                label: 'Editar',
                onClick: () => setUpdateIsOpen(true),
                operationKlassToCheckPermission: 'Admin::Establishment::Companies::UpdateMaintenanceModels',
              },
              {
                label: 'Remover',
                onClick: () => setDeleteIsOpen(true),
                className: '*:text-danger-soft',
                operationKlassToCheckPermission: 'Admin::Establishment::Companies::UpdateMaintenanceModels',
              },
            ]}
          />
        </div>

        <UpdateMaintenanceSpecificationModal
          establishmentCompany={establishmentCompany}
          maintenanceSpecification={maintenanceSpecification}
          alertText={alertText}
          isOpen={updateIsOpen}
          setIsOpen={setUpdateIsOpen}
        />

        <DeleteMaintenanceSpecificationModal
          establishmentCompany={establishmentCompany}
          maintenanceSpecification={maintenanceSpecification}
          isOpen={deleteIsOpen}
          setIsOpen={setDeleteIsOpen}
        />
      </div>
    </div>
  );
}

export default MaintenanceSpecificationItem;
